import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';

export class SubjectJsonModel extends JsonApiModel {
  public static override readonly type = 'subjects';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public name!: string;

  @Field()
  public region!: string;

  @Field()
  public treeId!: string;

  @Field()
  public root!: boolean;

  @Field()
  public active!: boolean;

  @Field()
  public nodeType!: string;

  @Field()
  public children!: string[];

  @Field()
  public version!: number;

  @Field({
    parse: (value) => { return value ? new Date(value) : null; },
    serialize: (value) => { return value ? value.getTime().toString() : null; }
  })
  public updated!: Date;

  @Field()
  public changedBy!: string;

  @Field()
  public _t!: string;

  @Field()
  ageGroup!: string;

  @Field()
  public suggestion!: string[];
}
